import {
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'
import React, { FC, ReactElement } from 'react'

import { GenericModalFooter } from './GenericModalFooter'
import { ModalCloseButton } from './ModalCloseButton'

interface ConfirmationModalProps {
  isLoading?: boolean
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
  title: ReactElement | string
}
export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  children,
  isLoading,
  isOpen,
  onCancel,
  onConfirm,
  title,
}) => {
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      motionPreset="scale"
      onClose={onCancel}
      size="lg"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading
            color="deepPurple"
            size="xl"
            textAlign="left"
            textTransform="capitalize"
          >
            {title}
          </Heading>
        </ModalHeader>
        <ModalCloseButton aria-label="close" onClose={onCancel} />
        <ModalBody>
          <VStack alignItems="flex-start" spacing={5} w="100%">
            {children}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <GenericModalFooter
            actionButtonId="modal-navigate-btn"
            actionIcon="IconCheckmark"
            actionTextLabel="label.yes"
            cancelTextLabel="label.no"
            isLoadingAction={isLoading}
            onAction={onConfirm}
            onCancel={onCancel}
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
